"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUSPICIOUS_USER_AGENT_REGEX = exports.ActionType = exports.MAX_SESSION_TIME_DIFF_SECONDS = exports.MAX_SESSION_MODULES = exports.QUIZ_SESSION_EVENT_TYPE = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'session-service';
exports.QUIZ_SESSION_EVENT_TYPE = 'quizSession';
exports.MAX_SESSION_MODULES = 200;
exports.MAX_SESSION_TIME_DIFF_SECONDS = 86400; // one day
var ActionType;
(function (ActionType) {
    ActionType["EMIT_SESSION"] = "emit-session";
    ActionType["START_SESSION"] = "start-session";
    ActionType["SESSION_XP"] = "session-xp";
    ActionType["EXAM_QUESTION_XP"] = "exam-question-xp";
    ActionType["KEEP_CONNECTION_ALIVE"] = "keep-connection-alive";
    ActionType["USER_QUIZ_XP"] = "user-quiz-xp";
})(ActionType || (exports.ActionType = ActionType = {}));
exports.SUSPICIOUS_USER_AGENT_REGEX = /python|php|curl|axios/i;
//# sourceMappingURL=index.js.map